var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiLocalAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5599 3.90961C21.1499 4.49961 21.1499 5.44961 20.5599 6.02961L16.6699 9.91961L18.7899 19.1096L17.3799 20.5296L13.4999 13.0996L9.59994 16.9996L9.95994 19.4696L8.88994 20.5296L7.12994 17.3496L3.93994 15.5796L4.99994 14.4996L7.49994 14.8696L11.3699 10.9996L3.93994 7.08961L5.35994 5.67961L14.5499 7.79961L18.4399 3.90961C18.9999 3.32961 19.9999 3.32961 20.5599 3.90961Z",
    fill: "#184799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLocalAirport);
export default __webpack_public_path__ + "static/media/mdi_local-airport.03c691edbe1fa7281d6d34b6cbf6132f.svg";
export { ForwardRef as ReactComponent };